import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { getDateTime } from "../funktionen/globale-funktionen";

@Injectable({
  providedIn: "root",
})
export class UpdateService {
  constructor(
    private updates: SwUpdate,
    private toastrService: ToastrService
  ) {
    if (!environment.production) {
      return;
    }
    const created = new Date();
    updates.versionUpdates.subscribe((evt) => {
      if (evt.type === "VERSION_READY") {
        if (Math.abs(getDateTime(created).diffNow().seconds) < 5) {
          window.location.reload();
        } else {
          toastrService
            .info("Die Seite muss neu geladen werden, da eine neue Version der Website verfügbar ist", "Neu laden", {
              progressBar: true,
            })
            .onHidden.subscribe(() => {
              window.location.reload();
            });
        }
      }
    });
    updates.checkForUpdate();
    setInterval(() => {
      updates.checkForUpdate();
    }, 30000);
  }
}
